export const FETCH_PRODUCT_REQUEST = 'FETCH_PRODUCT_REQUEST';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAILURE = 'FETCH_PRODUCT_REQUEST';

export const FETCH_VARIANT_REQUEST = 'FETCH_VARIANT_REQUEST';
export const FETCH_VARIANT_SUCCESS = 'FETCH_VARIANT_SUCCESS';
export const FETCH_VARIANT_FAILURE = 'FETCH_VARIANT_FAILURE';
